/**
 * Environment Utilities
 * =====================
 * Helpers for environment-gated features (dev/staging only).
 */

const NODE_ENV = process.env.NODE_ENV || 'production';

export const isDevOrStaging = () =>
  NODE_ENV === 'development' || NODE_ENV === 'staging';
